import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Main from '@/components/pages/Main.vue';
import LogoAnimation from '@/materials/molecules/LogoAnimation.vue';
import { useStore } from '@/store/store';
import { onMounted } from 'vue';
import { changeTheme } from '@/logics/theme';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        onMounted(() => {
            changeTheme(store.getters.theme);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Suspense, null, {
                default: _withCtx(() => [
                    _createVNode(Main)
                ]),
                fallback: _withCtx(() => [
                    _createVNode(LogoAnimation)
                ]),
                _: 1
            }));
        };
    }
});
